function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import EyeIcon from 'svg/eye.svg';
import EyeOffIcon from 'svg/eye-off.svg';
import { usePasswordToggle, useInputValue } from './hooks';
const Input = ({ id, type = 'text', value = '', className, classNameWrapper, placeholder, hasError = false, isDisabled = false, attributes, onChange, onBlur })=>{
    const intl = useIntl();
    const { isPassword, inputType, showPassword, togglePassword } = usePasswordToggle(type);
    const getValue = useInputValue(type);
    const resolvedPlaceholder = typeof placeholder === 'object' ? intl.formatMessage(placeholder, placeholder.values) : placeholder;
    const onChangeInput = useCallback((evt)=>{
        onChange({
            id,
            value: getValue(evt)
        });
    }, [
        id,
        onChange,
        getValue
    ]);
    const onBlurInput = useCallback((evt)=>{
        onBlur === null || onBlur === void 0 ? void 0 : onBlur({
            id,
            value: getValue(evt)
        });
    }, [
        id,
        onBlur,
        getValue
    ]);
    const Eye = showPassword ? EyeIcon : EyeOffIcon;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('input-container', classNameWrapper),
        children: [
            /*#__PURE__*/ _jsx("input", _object_spread({
                id: id,
                type: inputType,
                value: value,
                autoComplete: isPassword ? 'off' : 'on',
                disabled: isDisabled,
                className: cn({
                    'form-control': type !== 'checkbox' && type !== 'radio',
                    'border-danger': hasError
                }, className),
                placeholder: resolvedPlaceholder,
                onChange: onChangeInput,
                onBlur: onBlurInput
            }, attributes)),
            isPassword && /*#__PURE__*/ _jsx(Eye, {
                onClick: togglePassword
            })
        ]
    });
};
export default /*#__PURE__*/ memo(Input);
